import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCents(cents: number | null | undefined): string {
  return `$${((cents ?? 0) / 100).toFixed(2)}`;
}

export function formatUnixDate(unix: number | null | undefined): string {
  if (!unix) return '—';
  return new Date(unix * 1000).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export const HEALTHY_STRIPE_STATUSES = [
  'active',
  'trialing',
  'past_due',
] as const;

export function isHealthySubscriptionStatus(
  status: string | null | undefined
): boolean {
  return (
    !!status && (HEALTHY_STRIPE_STATUSES as readonly string[]).includes(status)
  );
}
